import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import contact from './contact'
import custom from './custom'
import dashboard from './dashboard'
import changeRequest from './changeRequest'
import profile from './profile/profile.reducer'
import modal from './modal/modal.reducer'
import toast from './toast/toast.reducer'


const rootReducer = (history) => combineReducers({
  router: connectRouter(history),
  dashboard,
  contact,
  changeRequest,
  custom,
  profile,
  modal,
  toast
})

export default rootReducer
